import { render, staticRenderFns } from "./alarmConfigList.vue?vue&type=template&id=7bfe8c3c&scoped=true"
import script from "./alarmConfigList.vue?vue&type=script&lang=js"
export * from "./alarmConfigList.vue?vue&type=script&lang=js"
import style0 from "./alarmConfigList.vue?vue&type=style&index=0&id=7bfe8c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfe8c3c",
  null
  
)

export default component.exports